<script lang="ts">
    import src from './svg/arrow_drop_down_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let style: string = '';
</script>

<TemplateIcon {src} {scale} {style} alt="Drop down" on:click />
